import React from "react";

import { Icon } from "components/Icon";

import { MIN_RATE_VALUE, ALLOCATION_NUMBER_LIMIT_PANEL } from "const";
import { methodByService } from "const/apiMethods";
import { getTargetByService } from "utils";
import MyForm from "components/MyForm";
import Text from "components/Form/Text";
import NumberField from "components/Form/NumberField";

import { Form, Schema } from "rsuite";

const { NumberType } = Schema.Types;


export default ({
    activeTab, onSelect, target, showResult, setHideBufferButtons, activeTrunk,
    setSummaryState, setTransactionId, setTotalNumbersForced, setCsvContent,
    setAllocateByPrefixesStatus, setNotAllocatedNumbers, service, getNewNumbers, updateTrunks,
    ...props
}) => {

    const [valueStartNumber, setValueStartNumber] = React.useState("");
    const [valueForm, setValueForm] = React.useState({ numbers: 1 });
    const [showRateInput, onChangeShowRateInput] = React.useState(null);
    const [customRateValue, onChangeCustomRateValue] = React.useState(null);

    const handleFormChange = async (newFormValues) => {
        setValueForm(newFormValues);
    };

    const model = {
        rate: NumberType()
            .min(MIN_RATE_VALUE, `The minimum of this field is ${MIN_RATE_VALUE}`)
            .max(10, "The maximum of this field is 10"),
        numbers: NumberType()
            .isRequired("Required")
            .isInteger("Only whole numbers")
            .addRule((value, data) => {
                if (value > ALLOCATION_NUMBER_LIMIT_PANEL) {
                    return false
                }
                return true;
            }, `The maximum of this field is ${ALLOCATION_NUMBER_LIMIT_PANEL}`),
    };


    const handleUpdateNew = ({ trunk_number_transaction, not_allocated_numbers }) => {
        if (trunk_number_transaction) {
            const transactionId = trunk_number_transaction.id;
            const summaryInfo = { ...trunk_number_transaction };

            getNewNumbers(service, transactionId);
            updateTrunks && updateTrunks();

            setSummaryState(summaryInfo);
            setTransactionId(transactionId);

            setTotalNumbersForced(summaryInfo.numbers);
            setAllocateByPrefixesStatus(false);
            setHideBufferButtons(false);
            setNotAllocatedNumbers(not_allocated_numbers);
            showResult();
        }
    };

    return (
        <>
            <MyForm
                activeTrunk={activeTrunk}
                target={getTargetByService(target, service)}
                method={methodByService["number_sequence"][service]}
                checkResultKey="price_range_number_list"
                update={handleUpdateNew}
                {...props}
                allocateByPrefixesStatus={null}
                className="numberForm"
                onChange={handleFormChange}
                formValue={valueForm}
                addData={{
                    rate: customRateValue !== null ? +customRateValue : null
                }}
                model={model}

                deepCloned={true}
            >

                <Text
                    name="start_number"
                    validationKey={null}
                    label="First number" width="md"
                    onChange={(value) => {
                        setValueStartNumber(value);
                    }}
                    value={valueStartNumber}
                    placeholder="1234567890"
                />

                <NumberField name="numbers" label="Amount" min={1} max={ALLOCATION_NUMBER_LIMIT_PANEL} />

                <br />

                {/* Show Rate form */}
                {!showRateInput

                    ? <div
                        style={{ cursor: "pointer", margin: "8px 20px 0 0", display: "inline-block" }}
                        onClick={() => { onChangeShowRateInput(true) }}
                    >
                        <Icon icon="book"
                            inverse
                            style={{ color: "var(--color-main)", marginRight: "5px" }}
                        />
                        <span style={{ color: "var(--color-main)" }}>Put custom rate</span>
                    </div>
                    : <>
                        <div style={{ display: "inline-block", marginTop: "8px", marginRight: "10px" }}>Rate</div>
                        <div style={{ display: "inline-block", marginRight: "10px" }}>
                            <Form.Control
                                style={{ width: 140 }}
                                errorPlacement="bottomStart"
                                placeholder="0.0001"
                                name="rate"
                                value={customRateValue}
                                onChange={(value) => {
                                    onChangeCustomRateValue(value);
                                }}
                            />
                        </div>
                        <div style={{ display: "inline-block", marginTop: "8px", marginRight: "10px" }}>
                            <Icon
                                icon="close"
                                inverse
                                style={{
                                    color: "var(--color-main)",
                                    marginRight: "5px",
                                    cursor: "pointer"
                                }}
                                onClick={() => {
                                    onChangeShowRateInput(false);
                                    onChangeCustomRateValue(null)
                                }}
                            />
                        </div>
                    </>
                }
            </MyForm>
        </>
    );
};
